import FoiMultiBrandCopyPage from "@faire/prototype-playground/workspace/kb/foi-multi-brand-copy";
import NestedRadioBlockCheckboxPage from "@faire/prototype-playground/workspace/kb/nested-radio-block-checkbox";
import NestedRadioBlockDropdownPage from "@faire/prototype-playground/workspace/kb/nested-radio-block-dropdown";
import SignupCongratulationsPage from "@faire/prototype-playground/workspace/kb/signup-congratulations";
import { Route, Switch } from "react-router-dom";

import CheckoutPage from "../../workspace/kb/checkout";

export function KasiaBedkowskiRoutes() {
  return (
    <Switch>
      <Route path="/kb/checkout" component={CheckoutPage} />
      <Route
        path="/kb/foi-multi-brand-copy"
        component={FoiMultiBrandCopyPage}
      />
      <Route
        path="/kb/nested-radio-block-checkbox"
        component={NestedRadioBlockCheckboxPage}
      />
      <Route
        path="/kb/nested-radio-block-dropdown"
        component={NestedRadioBlockDropdownPage}
      />
      <Route
        path="/kb/signup-congratulations"
        component={SignupCongratulationsPage}
      />
    </Switch>
  );
}

export const slug = "kb";
